import React, { Component } from 'react';
import './styles.css';

export default class MyJourney extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>My Journey Page</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/MyJourney/MyJourney.js